import {Action} from '@ngrx/store';

export const GET_HOURS = '[Stats] Get Hours';
export const GET_HOURS_SUCCESS = '[Stats] Get Hours Success';
export const GET_HOURS_ERROR = '[Stats] Get Hours Error';


export class GetHours implements Action {
  readonly type = GET_HOURS;

  constructor(public payload: any) {
  }
}

export class GetHoursSuccess implements Action {
  readonly type = GET_HOURS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetHoursError implements Action {
  readonly type = GET_HOURS_ERROR;

  constructor(public payload: any) {
  }
}

export type HoursAction =
  GetHours
  | GetHoursSuccess
  | GetHoursError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/actions/hours.action.ts